import { render, staticRenderFns } from "./VehicleManufactoreBodySelect.vue?vue&type=template&id=4e42416f"
import script from "./VehicleManufactoreBodySelect.vue?vue&type=script&lang=js"
export * from "./VehicleManufactoreBodySelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports